import { render, staticRenderFns } from "./TaskNewFormFrGroup.vue?vue&type=template&id=17c48320&"
import script from "./TaskNewFormFrGroup.vue?vue&type=script&lang=js&"
export * from "./TaskNewFormFrGroup.vue?vue&type=script&lang=js&"
import style0 from "./TaskNewFormFrGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports